import type { FormEvent, KeyboardEvent, RefObject } from 'react'
import type { AssessmentResponse } from '~/api/types'
import { ErrorBanner } from '~/components/ui/error-banner'
import { ChangeDescriptionField } from './change-description-field'
import { ClarificationStepper } from './clarification-stepper'
import { MobileAssessmentSelect } from './mobile-assessment-select'
import type { PendingClarification } from './types'

type ChangeInputFormProps = {
    assessments: AssessmentResponse[]
    selectedId: string
    selectedAssessment?: AssessmentResponse
    description: string
    pendingClarification: PendingClarification | null
    followUpMode: boolean
    actionError: string | null
    submitting: boolean
    textareaRef: RefObject<HTMLTextAreaElement | null>
    onSelectAssessment: (value: string) => void
    onDescriptionChange: (value: string) => void
    onSubmit: (e: FormEvent<HTMLFormElement>) => void
    onDescriptionKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void
    onSubmitClarification: (combined: string) => void
}

/** 유지하기 분석 흐름의 하단 변경 입력 폼. */
export function ChangeInputForm({
    assessments,
    selectedId,
    selectedAssessment,
    description,
    pendingClarification,
    followUpMode,
    actionError,
    submitting,
    textareaRef,
    onSelectAssessment,
    onDescriptionChange,
    onSubmit,
    onDescriptionKeyDown,
    onSubmitClarification,
}: ChangeInputFormProps) {
    return (
        <form
            onSubmit={onSubmit}
            className='border-border bg-card shrink-0 border-t p-3'>
            <div className='grid gap-3'>
                <MobileAssessmentSelect
                    assessments={assessments}
                    selectedId={selectedId}
                    selectedAssessment={selectedAssessment}
                    onSelectAssessment={onSelectAssessment}
                />
                {pendingClarification &&
                pendingClarification.questions.length > 0 ? (
                    <ClarificationStepper
                        key={pendingClarification.questions
                            .map((q) => q.question)
                            .join('|')}
                        questions={pendingClarification.questions}
                        submitting={submitting}
                        onAnswersChange={onDescriptionChange}
                        onComplete={onSubmitClarification}
                    />
                ) : (
                    <ChangeDescriptionField
                        description={description}
                        pendingClarification={pendingClarification}
                        followUpMode={followUpMode}
                        submitting={submitting}
                        textareaRef={textareaRef}
                        onDescriptionChange={onDescriptionChange}
                        onDescriptionKeyDown={onDescriptionKeyDown}
                    />
                )}
            </div>

            {actionError ? (
                <ErrorBanner className='mt-3'>{actionError}</ErrorBanner>
            ) : null}
        </form>
    )
}
